import React, { useState, useEffect } from 'react';
import { Box, Typography, Select, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row', // Horizontal by default on desktop
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  border: '1px solid #e2e8f0',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column', // Stack vertically on mobile
    alignItems: 'stretch',
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: '#1a202c',
  fontFamily: "'Source Serif Pro', serif",
  fontWeight: 600,
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: '200px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    '&:hover fieldset': {
      borderColor: '#cbd5e0',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2563eb',
    },
  },
  '& .MuiSelect-select': {
    color: '#2d3748',
    fontFamily: "'Inter', sans-serif",
  },
}));

export default function ReportSelector({ token, reports, onSelectReport, onAddReport }) {
  const [selectedReportId, setSelectedReportId] = useState('');
  const [hasSelectedInitialReport, setHasSelectedInitialReport] = useState(false);

  useEffect(() => {
    if (reports.length > 0 && !hasSelectedInitialReport) {
      setSelectedReportId(reports[0]._id);
      onSelectReport(reports[0]);
      setHasSelectedInitialReport(true);
    } else if (reports.length === 0) {
      setSelectedReportId('');
      onSelectReport(null);
      setHasSelectedInitialReport(false);
    }
  }, [reports, onSelectReport, hasSelectedInitialReport]);

  const handleSelectChange = (event) => {
    const reportId = event.target.value;
    setSelectedReportId(reportId);
    const selectedReport = reports.find(r => r._id === reportId);
    onSelectReport(selectedReport);
  };

  return (
    <StyledBox>
      <StyledTypography variant="h6" className="report-selector-title">
        Select Report:
      </StyledTypography>
      <StyledSelect
        value={selectedReportId}
        onChange={handleSelectChange}
        displayEmpty
        className="report-selector-select"
      >
        {reports.length === 0 ? (
          <MenuItem value="" disabled className="report-selector-menu-item">
            No reports available
          </MenuItem>
        ) : (
          reports.map(report => (
            <MenuItem key={report._id} value={report._id} className="report-selector-menu-item">
              {report.name}
            </MenuItem>
          ))
        )}
      </StyledSelect>
      <Button className="report-selector-button" onClick={onAddReport}>
        Add New Report
      </Button>
    </StyledBox>
  );
}